import * as React from 'react'

import { Checkbox } from '@/components/ui/checkbox'

interface AstaCheckboxProps
	extends Omit<React.ComponentPropsWithoutRef<typeof Checkbox>, 'onChange'> {
	onChange?: (
		event:
			| React.ChangeEvent<HTMLInputElement>
			| { target: { checked: boolean } }
	) => void
	indeterminate?: boolean
}

export const AstaCheckbox = React.forwardRef<
	React.ElementRef<typeof Checkbox>,
	AstaCheckboxProps
>(({ className, indeterminate, checked, onChange, ...props }, ref) => {
	const checkedState = indeterminate ? 'indeterminate' : checked

	return (
		<Checkbox
			ref={ref}
			className={className}
			checked={checkedState}
			onCheckedChange={value => {
				if (onChange) {
					onChange({
						target: {
							checked: value === true,
						},
					} as React.ChangeEvent<HTMLInputElement>)
				}
			}}
			{...props}
		/>
	)
})

AstaCheckbox.displayName = 'AstaCheckbox'
